module.exports = __webpack_public_path__ + "img/icon4.9e4e1ffd.svg";